import { FC, useEffect, useMemo } from 'react'

import styled from 'styled-components'

import CopyIcon from 'src/Assets/Svg/referAndEarn/copy.svg?react'
import { copyInviteEvent, getReferralShareEvent } from 'src/Helpers/TagManager'
import {
  getReferralCode,
  getUserSelector,
} from 'src/Redux/auth-process/userSlice/selectors'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { getReferralHashValue } from 'src/Redux/referral-process/referralHash'
import { getReferralHash } from 'src/Redux/referral-process/referralHash/api-actions'
import { create } from 'src/Router/routes'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { getSocialLinks } from './helpers'

import {
  ButtonsBlock,
  Description,
  InviteBlockContainer,
  InviteBlockTitle,
  ReferralLink,
  StyledCopyButton,
} from './styles'

const StyledButton = styled(GreyTextButton)`
  width: calc(100% / 3 - 16px);
  height: 48px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`
export const InviteBlock: FC = () => {
  const dispatch = useAppDispatch()
  const user = useAppSelector(getUserSelector)
  const referralCode = useAppSelector(getReferralCode)
  const referralHash = useAppSelector(getReferralHashValue)

  useEffect(() => {
    if (!referralCode && !referralHash) {
      void dispatch(getReferralHash())
    }
  }, [dispatch, referralCode, referralHash])
  const code = referralCode || referralHash
  const link = `${window.location.origin}${create}?referralCode=${code}`

  const socialLinks = useMemo(() => getSocialLinks(link), [link])

  return (
    <InviteBlockContainer>
      <div>
        <InviteBlockTitle>Start referring now</InviteBlockTitle>
        <Description>
          Give your friends $30 to kickstart their campaigns and earn a bonus
          ranging from $10 to $50 for each friend`s first paid campaign. The
          more you share, the more rewards roll in - with no limit to your
          earnings!
        </Description>
      </div>

      <ButtonsBlock>
        <StyledCopyButton
          disabled={code === ''}
          copiedText='Link copied'
          value={link}
          onClick={() => {
            copyInviteEvent({ userId: user.id, eventName: 'link' })
          }}
        >
          <CopyIcon /> Copy invite link
        </StyledCopyButton>
        {socialLinks.map(({ name, id, path, icon: Icon }) => (
          <StyledButton
            key={name}
            onClick={() =>
              getReferralShareEvent({ userId: user.id, buttonType: id })
            }
          >
            <ReferralLink target='blank' href={path}>
              <Icon />
              {name}
            </ReferralLink>
          </StyledButton>
        ))}
      </ButtonsBlock>
    </InviteBlockContainer>
  )
}
